import Swiper from 'swiper'

const SLIDER_CONFIG = {
	slidesPerView: 1.15,
	spaceBetween: 5,
	breakpoints: {
		990: {
			slidesPerView: 1.3,
		},
	},
}

function initUpsellSlider() {
	const el = document.querySelector('.js-upsell-slider')
	if (!el || el.classList.contains('swiper-initialized')) return

	if (window.sliders?.['js-upsell-slider']) {
		window.sliders['js-upsell-slider'].destroy(true, true)
	}

	// @ts-ignore
	window.sliders = {
		...window.sliders,
		'js-upsell-slider': new Swiper('.js-upsell-slider', SLIDER_CONFIG),
	}
}

export function handleUpsellSlider() {
	initUpsellSlider()
	const cartDrawer = document.querySelector('cart-drawer') || document.body
	new MutationObserver(() => {
		const el = document.querySelector('.js-upsell-slider')
		if (el && !el.classList.contains('swiper-initialized')) {
			initUpsellSlider()
		}
	}).observe(cartDrawer, { childList: true, subtree: true })
}